import {i18n} from 'src/biz_spa/plugins/i18n'

export const searchQueriesDataType = [
  {
    id: 'searchKeywordLabelBranded',
    name: i18n.t('models.analysis.searchQueriesDataType.searchKeywordLabelBranded.name'),
    text: i18n.t('models.analysis.searchQueriesDataType.searchKeywordLabelBranded.text'),
    dataType: 'impression_count',
    deactivateSort: true,
  },
  {
    id: 'searchKeywordLabelSelected',
    name: i18n.t('models.analysis.searchQueriesDataType.searchKeywordLabelSelected.name'),
    text: i18n.t('models.analysis.searchQueriesDataType.searchKeywordLabelSelected.text'),
    dataType: 'impression_count',
    deactivateSort: true,
  },
  {
    id: 'locale',
    name: i18n.t('models.analysis.searchQueriesDataType.locale.name'),
    dataType: 'locale',
    deactivateSort: true,
    align: 'left',
  },
  {
    id: 'impressionCount',
    name: i18n.t('models.analysis.searchQueriesDataType.impressionCount.name'),
    text: i18n.t('models.analysis.searchQueriesDataType.impressionCount.text'),
    dataType: 'impression_count',
  },
] as const

export const searchQueriesCrossAnalysisTypes = [
  {
    id: 'search_keyword',
    name: i18n.t('models.analysis.crossAnalysisTypes.searchQuery.name'),
    fields: 'search_keyword_id',
  },
] as const
